import React, { useEffect } from 'react';

export const withPageTitle = <T extends object>(WrappedComponent: React.ComponentType<T>, title: string) => {
  const WithPageTitle = (props: T) => {
    useEffect(() => {
      document.title = title;
    }, []);

    return <WrappedComponent {...props} />;
  };

  return WithPageTitle;
};

export default withPageTitle;
